import React, { ReactNode, forwardRef, useEffect, useState } from "react";
import { Icon } from "@campgladiator/cgui-core.atoms.icon";
import styles from "./checkbox.module.scss";
import classNames from "classnames";

export type CheckboxProps = {
  /**
   * The text that will appear as the label for the checkbox
   */
  children?: ReactNode;
  className?: string;
  /**
   * Callback function which returns the boolean state of the checkbox (true = checked)
   */
  onStateChange?: (isActive: boolean) => void;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    { children, className, onStateChange = () => {}, ...props }: CheckboxProps,
    ref
  ) => {
    const [isActive, setIsActive] = useState<boolean>(
      props.defaultChecked || false
    );

    useEffect(() => {
      onStateChange(isActive);
    }, [isActive, onStateChange]);

    return (
      <label
        className={classNames(styles.container, className)}
        style={props.style}
      >
        <input
          {...props}
          checked={isActive}
          className={styles.checkbox}
          onChange={() => setIsActive(!isActive)}
          ref={ref}
          type="checkbox"
        />
        <span
          className={styles.checkmark}
          data-active={isActive}
          data-disabled={props.disabled}
        >
          <Icon.Line className={styles.icon} name="icon-check" />
        </span>
        {children && <div className={styles.content}>{children}</div>}
      </label>
    );
  }
);

export default Checkbox;
